export const subPageTitle = new Map([
    ['contact', 'お問い合わせ'],
    ['faq', 'よくあるご質問'],
    ['manual', '操作マニュアル'],
    ['search', '検索'],
    ['starter', '導入の手引き'],
    ['camsta', 'キャムスタ！'],
]);

export const getSubPageTitle = (subPageId :string) => {
    return subPageTitle.get(subPageId);
}

export const machPath = (url1:string, url2:string)=> {
    return addSlashSlug(url1) === addSlashSlug(url2);
}

export const addSlashSlug = (slug:string)=> {
    //前後にスラッシュがある状態にする
    if (!slug.startsWith(`/`)){
        slug = '/' + slug;
    }
    if (!slug.endsWith('/')) {
        slug = slug + '/';
    }
    return slug;
}